import Swiper, { Navigation, Pagination } from 'swiper';

$(function() {

  // if($('.js-detail-swiper').length){
  //   const detailImage = new Swiper('.js-detail-swiper', {
  //     modules: [Navigation, Pagination],
  //     slidesPerView:1,
  //     spaceBetween: 0,
  //     loop: true,
  //     pagination: {
  //       el: '.js-detail-swiper-pagination',
  //       clickable: true
  //     },
  //     navigation: {
  //       nextEl: ".swiper-button-next-detail",
  //       prevEl: ".swiper-button-prev-detail"
  //     },
  //   });
  //   detailImage.init();
  // }

  if($('.js-similar-swiper').length){
    const similarSwiper = new Swiper('.js-similar-swiper', {
      modules: [Navigation, Pagination],
      slidesPerView:1,
      spaceBetween: 200,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-similar-next',
        prevEl: '.swiper-similar-prev',
      },
    });
    similarSwiper.init();
  }
  if($('.js-history-swiper').length){
    const historySwiper = new Swiper('.js-history-swiper', {
      modules: [Navigation, Pagination],
      slidesPerView:1,
      spaceBetween: 200,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-history-next',
        prevEl: '.swiper-history-prev',
      },
    });
    historySwiper.init();
  }
});
$(function() {
  const slideLength = document.querySelectorAll('.js-detail-swiper .swiper-slide').length

  if (slideLength > 1) {
    if($('.js-detail-swiper').length){
      const detailImage = new Swiper('.js-detail-swiper', {
        modules: [Navigation, Pagination],
        slidesPerView:1,
        spaceBetween: 0,
        loop: true,
        pagination: {
          el: '.js-detail-swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: ".js-detail-swiper-button-next-detail",
          prevEl: ".js-detail-swiper-button-prev-detail"
        },
      });
      detailImage.init();
    }
  } else {
    $('.js-detail-swiper-button-next-detail , .js-detail-swiper-button-prev-detail').addClass('pagenation-disabled');
}
});
